import { VF_DROPZONE } from 'AppSrc/core/components/forms/form-base-components/v-f-dropzone';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  ATTACHED_FILE,
  REMEDY_UPLOAD,
} from './work-information-item-constants';

const fieldId = ATTACHED_FILE;

const validator = (params) => {
  const {
    values,
    field,
    // crqID,
  } = params;
  const {
    optional,
    // checkfun,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_DROPZONE);

  /* VALIDATION FOR SIA ITEM */
  const isSIA = values.work_items;

  /* ADD ERRORS TO ERROR OBJECT */
  const checking = values.check ? values.check : false;
  if (checking) {
    errors[INLINE_ERRORS].push(null);
    // cleanUpFieldErrors(errors);
  }
  else {
    values.summary.replace(REMEDY_UPLOAD, '');
    errors[INLINE_ERRORS].push((noValue && !optional || (noValue && isSIA === '9000')) ? 'Attachment required for selected Work Info type' : null);
  }
  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};



const initialValues = null;

const vFParams = {
  fieldTitle: 'Attached file',
  acceptedFileTypes: [
    '.pdf',
    '.jpg',
    '.png',
    '.bmp',
    '.xls',
    '.xlsx',
    '.doc',
    '.docx',
    '.txt',
    '.csv',
    '.msg',
    '.rtf',
    '.zip',
    '.xml',
    '.docm',
  ],
  maxSize: 100, // in mb
};

const attachedFile = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_DROPZONE,
};

export { attachedFile };
